import { ANNUALLY, MONTHLY } from '@constants/billingPeriods'
import { SaveAmountOnBadge } from '@pages/Checkout/routes/components/SaveAmountOnBadge'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Divider, Heading, Panel, Radio, Spacer, Spreader } from '@ui-kit'
import { useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'

export const BillingPeriodPanel = () => {
  const { t } = useTranslation()

  const { chosenBillingPeriod, toggleBillingPeriod } = useCheckoutContext()

  return (
    <Panel border='neutral-2' padding={0} surface={0}>
      <Spacer space={30} />

      <Panel
        padding={{
          x: 30,
          y: 0
        }}
        surface={0}
      >
        <Heading level={3} weight={600}>
          {t('checkout.configure.billing.period')}
        </Heading>

        <Spacer space={20} />

        <Row>
          <Radio
            id={String(MONTHLY)}
            field={{
              name: String(MONTHLY),
              value:
                chosenBillingPeriod === MONTHLY
                  ? String(MONTHLY)
                  : String(ANNUALLY),
              onChange: toggleBillingPeriod
            }}
            label={t('checkout.configure.billing.monthly')}
          />
        </Row>
      </Panel>

      <Spacer space={20} />

      <Divider />

      <Spacer space={20} />

      <Panel
        padding={{
          x: 30,
          y: 0
        }}
        surface={0}
      >
        <Row>
          <Radio
            id={String(ANNUALLY)}
            field={{
              name: String(ANNUALLY),
              value:
                chosenBillingPeriod === ANNUALLY
                  ? String(ANNUALLY)
                  : String(MONTHLY),
              onChange: toggleBillingPeriod
            }}
            label={t('checkout.configure.billing.annually')}
          />

          <Spreader spread={15} />

          <SaveAmountOnBadge />
        </Row>
      </Panel>

      <Spacer space={30} />
    </Panel>
  )
}
